<template>
	<button v-if="button" class="sbutton" @click.prevent="showModal = true">
		<sym-icon name="upload"/> <span>{{bundleDoc}}</span>
	</button>
	<a v-else href="#" @click.prevent="showModal = true" :class="styleClass"><sym-icon name="upload"/></a>
	<Teleport to="body">
		<modal :show="showModal" @close="showModal = false">
			<template #body>
				<open-file-browser :volume="volume" :filter="filter" :preview="preview"
					:disable-client-storage="disableClientStorage" @selected="selected" @close="showModal = false"/>
			</template>
		</modal>
	</Teleport>
</template>
<script setup lang="ts">
import OpenFileBrowser from './OpenFileBrowser.vue';
import Modal from '../modal/Modal.vue';
import SymIcon from "@fd/helpers/SymIcon.vue";
import type {FolderStructure} from "./FolderStructure";
import { ref } from 'vue';
import {injectEnv} from "@fd/Environment";

const props = defineProps({
		volume: { type: String, required: false, default: "attFile" },
		filter: String,
		preview: Boolean,
		title: { type: String, required: false },
		disableClientStorage: { type: Boolean, required: false, default: false },
		button: { type: Boolean, required: false, default: true }
	});

const env = injectEnv();
const bundleDoc= env.msg(props.title?props.title:"fileZone.fromDocuments");
const showModal = ref(false);

const emit = defineEmits(['selected']);

function selected(files: FolderStructure[]): void
{
	emit('selected',files);
	showModal.value = false;
}
</script>
